import { createFileAttachmentDraft, useFileAttachments, type FileAttachmentDraft } from '~/composables/files/useFileAttachments';
import type { UploadedFile } from '~/types/models';

export type MessageAttachmentDraft = FileAttachmentDraft;
export const createMessageAttachmentDraft = createFileAttachmentDraft;

export function useMessageAttachments(options: {
    clientId?: MaybeRefOrGetter<string>;
    tenantId: MaybeRefOrGetter<string>;
    portal?: boolean;
    entityType?: MaybeRefOrGetter<UploadedFile['entityType']>;
    entityId?: MaybeRefOrGetter<string>;
    contextLabel?: string;
}) {
    return useFileAttachments(options);
}
